import { render, staticRenderFns } from "./ActivitySidebar.vue?vue&type=template&id=521991be&"
import script from "./ActivitySidebar.vue?vue&type=script&lang=js&"
export * from "./ActivitySidebar.vue?vue&type=script&lang=js&"
import style0 from "./ActivitySidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521991be')) {
      api.createRecord('521991be', component.options)
    } else {
      api.reload('521991be', component.options)
    }
    module.hot.accept("./ActivitySidebar.vue?vue&type=template&id=521991be&", function () {
      api.rerender('521991be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/ActivitySidebar.vue"
export default component.exports